import React from "react";
import {
  Dialog,
  Typography,
  Box,
  IconButton,
  makeStyles,
  DialogTitle,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Slider from "react-slick";
import MediaWidget from "./MediaWidget";
import ThemeColors from "../config/colors";

const useStyles = makeStyles(() => ({
  titleBackground: {
    backgroundColor: ThemeColors.dialogTitleBackground,
  },
  background: {
    height: "52vh",
  },
  slider: {
    width: "80%",
  },
}));

const MediaCarouselDialog = ({ open = false, onClose, media, current = 0 }) => {
  const classes = useStyles();

  return (
    <Dialog
      onClose={onClose}
      open={open}
      PaperProps={{
        style: { borderRadius: 14 },
      }}
      fullWidth
    >
      <DialogTitle className={classes.titleBackground}>
        <Box className="d-flex align-items-center justify-content-between">
          <Typography variant="h4" className="font-weight-semibold mx-3">
            Media
          </Typography>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <Box className={classes.background}>
        <Box className="d-flex align-items-center justify-content-center">
          <Slider
            className={classes.slider}
            dots={true}
            arrows={true}
            infinite={true}
            speed={300}
            initialSlide={current}
            lazyLoad="ondemand"
          >
            {media?.map((e, index) => (
              <div key={index}>
                <MediaWidget
                  media={e}
                  style={{
                    width: "100%",
                    height: "48vh",
                    objectFit: "contain",
                  }}
                />
              </div>
            ))}
          </Slider>
        </Box>
      </Box>
    </Dialog>
  );
};

export default MediaCarouselDialog;
